import { TokenInfo } from '../types';

declare global {
  interface Window {
    bmak?: { get_telemetry?: () => string };
  }
}

export type LoginFormConfig = {
  showCreatePasswordLink: boolean;
  showForgetInfoLink: boolean;
  showJoinLink: boolean;
  showSecureInfoLink: boolean;
  joinOcode?: string;
  forwardPageURL?: string;
  /**
   * When true, eligible footer links (for example "Forgot your info" and "Your information is secure")
   * show a new-window / external-link indicator alongside the link text.
   */
  isNewWindow?: boolean;
  onJoinClick?: () => void;
  joinFromModal?: boolean;
  isPartner?: boolean;
};

export type SourceID = 'OHW' | 'groups360';

export type DeliveryMethod = 'sms' | 'email';

export type GuestAuthResponse = {
  userInfo: GuestUserInfo;
  remember: boolean;
  // @deprecated
  tokenInfo: TokenInfo;
};

export type AutoLoginResponse = {
  autoLoginStatus: string;
  guestId: number;
  hhonorsNumber?: string;
  accessToken: string;
};

export type GuestLoginHandler = 'onLogin' | 'clearUser' | 'close';

export type LoginFormResponse = {
  autoLoginData?: AutoLoginResponse;
  deliveryMethod?: DeliveryMethod;
  challengeToken?: string;
  validated?: boolean;
  handler?: GuestLoginHandler;
  status?: LoginStatusType;
  error?: LoginError;
  data?: GuestAuthResponse;
  height?: number;
};

export type LoginData = {
  hhonorsNumber: number | undefined;
  hhonorsPackageCodes: string[] | undefined;
  hhonorsTier: string | undefined;
};

type GuestUserInfo = {
  keyIdentifier: number;
  guestId: number;
  domainUserName: string;
  userRealm: string;
  hhonorsNumber: number;
  hhonorsPackageCodes?: string[];
  hhonorsTier?: string;
  partnerHhonorsNumber?: number;
  username: string;
};

export const LoginStatus = {
  CONTINUE: 'CONTINUE',
  CHALLENGE: 'CHALLENGE',
  FAILED_AUTH: 'FAILED_AUTH',
  FAILED_RECAPTCHA: 'FAILED_RECAPTCHA',
  STUCK_ON_LOGIN: 'SOL',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR',
  UNEXPECTED_ERROR: 'UNEXPECTED_ERROR',
  VALIDATION_ERROR: 'VALIDATION_ERROR',
} as const;

export type LoginStatusType = ValuesOf<typeof LoginStatus>;

export const LoginErrors = {
  INVALID_CALLBACK: 'invalid_callback',
  INVALID_ENTRY: 'invalid_entry',
  INVALID_GRANT: 'invalid_grant',
  STUCK_ON_LOGIN: 'sol',
  UNKNOWN_ERROR: 'unknown_error',
  UNAUTHORIZED_CLIENT: 'unauthorized_client',
  UNEXPECTED_ERROR: 'unexpected_error',
  ACCOUNT_ADMIN_LOCKED: 'account_admin_locked',
  ACCOUNT_LOCKED: 'account_locked',
} as const;

export type LoginError = { status: (typeof LoginErrors)[keyof typeof LoginErrors] };
